module.exports = __webpack_public_path__ + "static/media/newLogo.3c2345b6.gif";